import { useEffect, useRef } from 'react'
import { useTranslation } from '../../i18n/I18nProvider'

const Alert = ({ msg, error = false, success = false, close, className = '' }) => {
  const { translations } = useTranslation()
  const cs = translations?.common || {}
  const buttonRef = useRef(null)
  const containerRef = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      buttonRef.current?.focus()
    }, 0)

    const handleFocusIn = (e) => {
      if (containerRef.current && !containerRef.current.contains(document.activeElement)) {
        setTimeout(() => {
          buttonRef.current?.focus()
        }, 0);
      }
    }
    document.addEventListener('focusin', handleFocusIn)
    return () => {
      document.removeEventListener('focusin', handleFocusIn)
    }
  }, [])

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      close()
    }
  }
  const getMsg = () => msg || (success ? '✅ Operation completed successfully' : '❌ An error has occurred');
  return (
    <div className="alert" onClick={close}>
      <div  ref={containerRef}
        className={`alert--content${error ? ' error' : ''}${success ? ' success' : ''} ${className}`}
        onClick={(e) => e.stopPropagation()}
        style={{'whiteSpace':'pre-line'}}
      >
        {getMsg()}
        {
          <button
            id={`okayButton`}
            style={{ display: 'block' }}
            ref={buttonRef}
            className="err-btn btn btn-primary"
            onClick={() => close()}
            onKeyDown={handleKeyDown}
          >
            {cs.ok || 'Ok'}
          </button>
        }
      </div>
    </div>
  )
}

export default Alert
